var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserguidesNavigator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.87 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-userguides-navigator") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.19,6.31l-.25.12v.25c0,1,.87,2.56,1.63,2.56S9.19,7.69,9.19,6.69c0-.81-.81-1.88-1.13-1.88A5,5,0,0,1,6.19,6.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.69,10.06l1.37-.44a1.73,1.73,0,0,1,.56-.06h.06A5.07,5.07,0,0,1,4.63,6.75a1.39,1.39,0,0,1,1-1.5A3.24,3.24,0,0,0,7,4.12a1.3,1.3,0,0,1,1-.5c1.25,0,2.38,1.94,2.38,3.13A4.64,4.64,0,0,1,9.31,9.56h0c.19,0,.38.06.56.06l1.38.44.31-3.25A5,5,0,0,0,9.75,2.44V2.31A2.35,2.35,0,0,0,7.44,0,2.29,2.29,0,0,0,5.19,2.31v.12A4.91,4.91,0,0,0,3.37,6.87ZM7.5,1.25a1,1,0,0,1,.87.5,4.22,4.22,0,0,0-.87-.13,3.69,3.69,0,0,0-.87.13A1,1,0,0,1,7.5,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.19,17.56h8.63a1.94,1.94,0,0,0,1.94-1.88V13.56a1.87,1.87,0,0,0-1.31-1.81l-2.88-.94a.63.63,0,0,0-.69.31L7.56,13.94,6.25,11.13a.63.63,0,0,0-.69-.31l-2.87.94a2,2,0,0,0-1.31,1.81v2.12A1.76,1.76,0,0,0,3.19,17.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.81,22.63a5.36,5.36,0,0,1-4,1.94,5.36,5.36,0,0,1-4-1.94,4.5,4.5,0,0,0-3.13,4.56,10.56,10.56,0,0,0,.19,1.88A1.19,1.19,0,0,0,17,30H28.5a1.2,1.2,0,0,0,1.19-.94,10.56,10.56,0,0,0,.19-1.88A4.46,4.46,0,0,0,26.81,22.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.69,15.06a18.48,18.48,0,0,0,5.63.38,4.84,4.84,0,0,0-4.5-3,4.89,4.89,0,0,0-4.69,3.5V16c0,.13-.06.19-.06.25a15.94,15.94,0,0,0,2.19-1A1.31,1.31,0,0,1,21.69,15.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.44,18.37a1.71,1.71,0,0,0,1.06,1.5c.75,1.81,2.31,3.44,4.31,3.44s3.5-1.69,4.31-3.44c.56-.13.94-.69,1.06-1.5a1.68,1.68,0,0,0-.56-1.69h0c-2.37.13-5.5-.06-6.44-.5a15.15,15.15,0,0,1-3.75,1.69A.68.68,0,0,0,17.44,18.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,20.31v3.31a.63.63,0,0,0,.62.63H3.31V19.69H.62A.63.63,0,0,0,0,20.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.44,19.69H4.56v4.56h9.88a.63.63,0,0,0,.63-.63V20.31A.67.67,0,0,0,14.44,19.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.19,11.19h6.25V6.69H13.19a.63.63,0,0,0-.63.63v3.25A.59.59,0,0,0,13.19,11.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,10.56V7.31a.63.63,0,0,0-.63-.63H20.62v4.5h6.75A.59.59,0,0,0,28,10.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserguidesNavigator);
export default __webpack_public_path__ + "static/media/icon-userguides-navigator.12fd890d965b5fc3fa52dd93e04686b2.svg";
export { ForwardRef as ReactComponent };